import { render, staticRenderFns } from "./AssetHealth.vue?vue&type=template&id=15b4a7d5&"
import script from "./AssetHealth.vue?vue&type=script&lang=js&"
export * from "./AssetHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports